import { render, staticRenderFns } from "./ProductSeo.vue?vue&type=template&id=87743a02&scoped=true"
import script from "./ProductSeo.vue?vue&type=script&lang=js"
export * from "./ProductSeo.vue?vue&type=script&lang=js"
import style0 from "./ProductSeo.vue?vue&type=style&index=0&id=87743a02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87743a02",
  null
  
)

export default component.exports